import { render, staticRenderFns } from "./PoolHeader.vue?vue&type=template&id=61c5a1cf&scoped=true&"
import script from "./PoolHeader.vue?vue&type=script&lang=js&"
export * from "./PoolHeader.vue?vue&type=script&lang=js&"
import style0 from "./PoolHeader.vue?vue&type=style&index=0&id=61c5a1cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c5a1cf",
  null
  
)

export default component.exports